import List from "../../containers/SearchTags/List";
import Entry from "../../containers/SearchTags";

const searchTagRoutes = [
  {
    path: "/search-tags",
    exact: true,
    auth: true,
    component: List
  },
  {
    path: "/search-tags/:type",
    exact: true,
    auth: true,
    component: Entry
  },
  {
    path: "/search-tags/:type/:id",
    exact: true,
    auth: true,
    component: Entry
  }
];

export default searchTagRoutes;



// WEBPACK FOOTER //
// ./src/routes/modules/searchTags.jsx